import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import HoverImage from 'react-hover-image/build';
import ReactStrapTable from 'components/reactStrapTable';

import API from 'utils/API';
import Drawer from 'components/Drawer';
import commonColumns from 'utils/columns';
import { GlobalComments } from 'components/Comments';
import NPIPorviderEdit from 'components/NPIPorviderEdit';
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import AttachIcon from 'assets/icon/icon-icon-options-attachment.svg';
import AttachHoverIcon from 'assets/icon/icon-icon-options-attachment_hover.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';

let tableDataBackup = [],
  rowForEdit = {};

const ClaimsManagerTable = (props) => {
  const {
    data,
    totalSize,
    onPageChange,
    loading,
    filters,
    onSearchColumnFilters = () => '',
    onExport,
    coveredEntity,
    refetch,
  } = props;

  tableDataBackup = data;
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(tableDataBackup);
  const [reset, setReset] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [drawer, setDrawer] = useState('');
  const [providerId, setProviderId] = useState('');
  const [commentDrawer, setCommentDrawer] = useState(false);
  const [commentRowData, setCommentRowData] = useState({});
  const { coveredEntityID, tenantID } = coveredEntity;

  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  const cellRenderEdit = (rowData) => {
    if (rowData.isEdit) {
      return (
        <div className='d-flex align-items-center'>
          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={saveUpdateRow}
          >
            <HoverImage
              key='SaveIcon'
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=''
            />
          </Button>
          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => editRow(rowData, false)}
          >
            <HoverImage
              key='CancelIcon'
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=''
            />
          </Button>
        </div>
      );
    } else {
      return (
        <div className='d-flex align-items-center'>
          <>
            <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={() => editRow(rowData)}
            >
              <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt='' />
            </Button>
            <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={() => toggleCommentDrawer(rowData)}
            >
              <HoverImage
                key='AttachIcon'
                src={AttachIcon}
                hoverSrc={AttachHoverIcon}
                alt=''
              />
            </Button>
          </>
        </div>
      );
    }
  };

  const saveUpdateRow = async () => {
    try {
      const postData = {
        claimID: rowForEdit['claimID'],
        statusID: rowForEdit['claimStatusID'],
        reasonDesc: rowForEdit['reasonDesc'],
      };
      setSubmitting(true);
      const { data } = await API.post(
        `/${tenantID}/Claim/UpdateStatus`,
        postData
      );
      if (data) {
        toast.success('Updated Successfully!');
        refetch();
      } else {
        console.log(' error ', data);
      }
      setSubmitting(false);
    } catch (err) {
      toast.error('An error occurred');
      console.error(err);
      setSubmitting(false);
    }
  };

  const handlClick = (id) => {
    navigate(`/claims-manager/${coveredEntityID}/${tenantID}/patient/${id}`);
  };

  const formatter = (row) => {
    const { patientID, patientFirstName } = row;
    return (
      <span
        className='cursor-pointer text-decoration-underline'
        onClick={() => handlClick(patientID)}
      >
        {patientFirstName}
      </span>
    );
  };

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
    setDrawer('');
  };

  const drawerClose = (hasUpdated) => {
    setIsOpen(!isOpen);
    setDrawer('');
    if (hasUpdated) refetch();
  };

  const handleProviderNPI = ({ providerNPI }) => {
    setIsOpen(!isOpen);
    setDrawer('npi');
    setProviderId(providerNPI);
  };

  const cellRenderProviderNPI = (row) => {
    const { providerNPI } = row;
    if (providerNPI) {
      return (
        <span
          className='cursor-pointer text-decoration-underline'
          onClick={() => handleProviderNPI(row)}
        >
          {providerNPI}
        </span>
      );
    }
    return '-';
  };

  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...tableDataBackup];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.claimID === rowData?.claimID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    tableDataBackup = tempData;
    setTableData(tempData);
  };

  const cellEditRender = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        hasEditable={col.edit}
        columnName={col.dataField}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
      />
    );
  };

  let copyCommonColumns = [...commonColumns];

  copyCommonColumns[4].cellRenderer = (row, col) =>
    cellEditRender(row, col, 'statusList');
  copyCommonColumns[5].cellRenderer = (row, col) =>
    cellEditRender(row, col, 'comments');
  copyCommonColumns[26].cellRenderer = cellRenderProviderNPI;

  let mainCol = [
    {
      dataField: 'edit',
      text: 'Options',
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 80,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: 'patientFirstName',
      text: 'Patient First Name',
      cellRenderer: (rowData) => formatter(rowData),
      sort: true,
      width: 144,
      show: true,
      inputType: 'text',
    },
    ...copyCommonColumns,
  ];

  mainCol.splice(2, 1);

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };

  const handleFilterCancel = () => {
    refetch();
  };

  const toggleCommentDrawer = (rowData) => {
    setCommentDrawer((pre) => !pre);
    setCommentRowData(rowData);
  };

  return (
    <div
      className='table-card scroll-table position-relative border-0 rounded pt-0'
      fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id='claims-manager-table'
        height={550}
        fixedColumn
        width={1200}
        reset={reset}
        hasPagination
        data={tableData}
        columns={mainCol}
        onExport={onExport}
        filters={filters}
        totalRecords={totalSize}
        pageSize={filters.pageSize}
        loading={loading || isSubmitting}
        currentPage={filters.currentPage}
        handleSort={onHandleSort}
        onPageChange={onHandlePageChange}
        onPageSizeChange={onPageSizeChange}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
      />
      <Drawer
        direction='end'
        isOpen={isOpen}
        toggle={toggleDrawer}
        title={`${
          drawer === 'npi' ? 'Update Provider (' + providerId + ')' : ''
        }`}
      >
        <NPIPorviderEdit
          tenantID={tenantID}
          providerId={providerId}
          coveredEntityID={coveredEntityID}
          onClose={drawerClose}
        />
      </Drawer>
      <Drawer
        direction='end'
        title='All Comments'
        isOpen={commentDrawer}
        toggle={toggleCommentDrawer}
      >
        <GlobalComments
          tenantID={tenantID}
          row={commentRowData}
          coveredEntityID={coveredEntityID}
          providerID={commentRowData?.providerID}
        />
      </Drawer>
    </div>
  );
};
export default ClaimsManagerTable;
